'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.inertialScrolling = void 0;
const $ = require("jquery");
const lenis_1 = require("lenis");
class inertialScrolling {
    constructor() {
        // .paramSmoothScrollがあるページのみで使用
        // 慣性スクロール
        if ($('.paramSmoothScroll').length) {
            const lenis = new lenis_1.default({
                autoRaf: true,
            });
        }
    }
}
exports.inertialScrolling = inertialScrolling;
exports.default = inertialScrolling;
